import React from "react";
import { HorizontalBar } from "react-chartjs-2";
import { horizontalBar } from "./_commonSharedChartOptions";
import { connect } from "react-redux";
import { setColor } from "../../../../views/Dashboard/dashboard/ColorPalette";
import { WidgetNoDataToDisplay, WidgetServerError } from "../../../../components/DashboardWidget/WidgetCommon";
import { taskUsageDataPreview } from "./_previewData";
const _ = require("lodash");

const widgetDetails = {
  Chart: "TOP_INTENT_BY_SKILL_BY_PLATFORM",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class TaskUsageContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  setWidgetDataColor(data) {
    data.map(item => {
      item.backgroundColor = setColor(item.label);
    });
    return data;
  }

  render() {
    const { widgetData, draggable } = this.props;

    return (
      <div>
        <div className="widgetTitle">Requests by Intent</div>
        <div className="widgetBody">
          {draggable ? (
            <WidgetServerError draggable={draggable} />
          ) : widgetData === undefined || draggable ? (
            <WidgetNoDataToDisplay draggable={draggable} />
          ) : (
            <HorizontalBar
              id={widgetDetails.Chart}
              data={{
                labels: widgetData.labels,
                datasets: this.setWidgetDataColor(widgetData.data_dict.Items)
              }}
              options={horizontalBar}
            />
          )}
        </div>
      </div>
    );
  }
}

export const TaskUsagePreview = () => {
  return (
    <div>
      <div className="widgetTitle">Requests by Intent</div>
      <div className="widgetBody">
        <HorizontalBar
          data={taskUsageDataPreview}
          options={_.merge({}, horizontalBar, {
            legend: { display: false },
            scales: {
              yAxes: [
                {
                  ticks: {
                    fontSize: 5
                  }
                }
              ]
            },
            plugins: {
              datalabels: {
                font: {
                  size: 5
                }
              }
            }
          })}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard.data["PlatformPerIntentRequest"]
  };
}

export const TaskUsageContent = connect(
  mapStateToProps,
  undefined
)(TaskUsageContentClass);
